import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';

interface RatingAndCountProps {
  displayValue: string;
  total?: number;
}
const RatingAndCount: FC<RatingAndCountProps> = ({ displayValue, total }) => (
  <Box display="flex" justifyContent="flex-start" alignItems="center">
    <Box
      borderRadius="4px"
      py={1}
      px={2}
      bg="primarylight"
      color="primary"
      fontWeight="bold"
    >
      {displayValue}
    </Box>
    {total && (
      <Box ml={1} color="darkergrey">
        {`(${total} ratings)`}
      </Box>
    )}
  </Box>
);

RatingAndCount.defaultProps = {
  total: undefined,
};

export default RatingAndCount;
